<template>
  <div class="main_home" style="width:100%;height:100%;overflow:hidden;">
    <div style="">
        <div class="main_header">
                <h1 style="font-size:30px;text-align: center;width: 100%;margin: 0 auto;padding: 0;background: #0072ff;line-height: 70px;color: white;">
                    {{ company.name }}
                </h1>
            </div>
            <div class="main_title">
                <ul>
                    <li>
                        <el-image fit="cover"  class="main_title_img" :src="require('@/assets/login_ico.png')">
                        </el-image>
                    </li>
                    <li>
                        <span>
                            用户登录
                        </span>
                    </li>
                </ul>
            </div>
            <div class="main_content">
                <ul style="text-align:center;">
                    <li style="margin-top:100px;" v-if="wechat_login">
                        <div class="qrcode_login">
                            <ul>
                                <li>
                                    <ul>
                                        <li>
                                            <el-image fit="cover"  class="wechat_login_ico" :src="require('@/assets/wechat.png')" style="width: 50px;height:50px;">
                                                
                                            </el-image>
                                        </li>
                                        <li style="margin-top:20px">
                                            <span>
                                                微信扫一扫自动注册登录
                                            </span>
                                        </li>
                                    </ul>
                                </li>
                                <li style="margin-top:20px" >
                                    <a-button v-if="isWeChatBrowser()" @click="wechat_login_action" style="margin-top:50px;background:#30D469;height:50px;color:white;font-size:16px;" type="Primary">点击微信授权登录</a-button>
                                    <wxlogin
                                        v-if="!isWeChatBrowser()"
                                        :appid="app_id"
                                        :scope="'snsapi_login'"
                                        :theme="'black'"
                                        :redirect_uri="encodeURIComponent(urls.wechat.redirect_feedback)"
                                        :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
                                    >
                                    </wxlogin>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li style="margin-top:100px;" v-if="!wechat_login">
                        <div class="normal_login">
                            <ul>
                                <li>
                                    <h1>
                                        您也可以选择手动注册
                                    </h1>
                                </li>
                                <li style="margin-top:20px;">
                                    <span>
                                        没有账号？点击下面按钮马上注册
                                    </span>
                                </li>
                                <li style="margin-top:20px;height:60px;">
                                    <router-link to="/user/register" style="display:block;width:100%;height:100%;background:#1890ff;line-height:60px;font-size:20px;color:white;border-radius:5px;">
                                        立即注册
                                    </router-link>
                                </li>
                                <li style="margin-top:20px;height:60px;">
                                    <router-link to="/user/login" style="display:block;width:100%;height:100%;background:#1890ff;line-height:60px;font-size:20px;color:white;border-radius:5px;">
                                        立即登录
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
    </div>
    
    <div class="home_footer" style="height:100px;">
        <ul style="width:100%;height:100%;">
            <li style="float:left;height:100%;width:40%;margin-left:10%;">
                <a @click="switch_login" to="/home" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/account_login.png')">
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                {{ switch_login_name }}
                            </a>
                        </li>
                    </ul>
                </a>
            </li>
            <li style="float:right;height:100%;width:40%;margin-right:10%;">
                <router-link to="/" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/quit.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                安全退出
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
        </ul>
    </div>
  </div>
</template>
<script type='text/javascript' src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>
<script>

import urls from "../../api/urls"
import wxlogin from 'vue-wxlogin'
import request from "../../api/request"
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'IndexHome',
    head: {
        title: "会员中心",
        meta:[
            { name: 'description', content: '会员中心'}
        ]
    },
    data: function() {
        return {
            wechat_login: true,
            switch_login_name: "账号密码登录",
            app_id: "wx3b807bbcedcfe6c2",
            mp_app_id: "wx3b807bbcedcfe6c2",
            urls: urls,
            is_wechat_browser: false,
            company: company_model,
            user: undefined,
        }
    },
    methods: {
        wechat_login_action() {
            request.site_user.wx_login(this.mp_app_id, urls.wechat.mp_redirect_feedback)
        },
        isWeChatBrowser() {
            var ua = window.navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true
            }
            else {
                return false
            }
        },
        fetch_user_info() {
            let user_info_resp = request.site_user.userinfo()
            user_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data != null && response.data.data != undefined) {
                        this.user = response.data.data
                        if (this.user && this.user.userid) {
                            this.$router.push('/order/list')
                        }
                    }
                }
            })
            
        },
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
            this.is_wechat_browser = this.isWeChatBrowser()
            this.fetch_user_info()
        },
        switch_login() {
            this.wechat_login = !this.wechat_login
            if (this.wechat_login) {
                this.switch_login_name = "账号密码登录"
            }
            else {
                this.switch_login_name = "微信登录"
            }
        }
    },
    created() {
        this.load()
    },
    components: {
        wxlogin
    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_home {
  height: 100%;
  margin: 0;
  padding: 0;
}

.main_header {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
}

.main_title {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    height: 50px;
}

.main_title ul {
    margin: 0 auto;
    padding: 0;
    height: 100%;
}


.main_title ul li {
    height: 100%;
    margin: 0 auto;
    padding: 0;
    float: left;
}

.main_title ul li:last-child {
    margin-left: 20px;
}

.main_title_img {
    width: 50px;
    height: 50px;
}

.main_title ul > li > span {
    display: block;
    margin: 0 auto;
    padding: 0;
    line-height: 50px;
    font-size: 20px;
}


.main_content {
    margin: 0;
    padding: 0;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 5%;
}

.main_content > ul {
    margin: 0;
    padding: 0;
    margin-top:30px;
}

.qrcode_login > ul {
    margin: 0;
    padding: 0;
}

.qrcode_login > ul > li {
    margin: 0;
    padding: 0;
}

.qrcode_login > ul > li > ul {
    margin: 0;
    padding: 0;
}

.qrcode_login > ul > li > ul > li {
    margin: 0;
    padding: 0;
}

.normal_login > ul {
    margin: 0;
    padding: 0;
}

.normal_login > ul > li {
    margin: 0;
    padding: 0;
}

.home_footer {
   position: fixed;
   left: 0;
   width: 100%;
   background-color: #99999955;
   color: white;
   bottom: 0;
   text-align: center;
   height:100px;
}

.home_footer ul {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
}

.home_footer ul li {
    width: 100%;
    list-style: none;
}

.home_footer ul li:first-child {
    width: 100%;
    height: 60px;
    margin: 0 auto;
}

.home_footer ul li:last-child {
    height: 40px;
}

.member_quit_a {
    width: 100%;
    height: 70px;
    line-height: 70px;
    display: block;
    text-align: center;
    margin: 0 auto;
    color: #999;
}
.impowerBox .title {display: none;}
.impowerBox .info {display: none;}
.status_icon {display: none}
.impowerBox .status {text-align: center;} 



</style>
